<template>
  <div style="display:inline-block">
    <el-button size="small" type="success" @click="showDialog">生成轮播图</el-button>
    <el-dialog title="生成轮播图" :visible.sync="dialogVisible" width="1150px">
      <el-form :inline="true" ref="addForm" :model="addForm">
        <el-table :height="tableHeight" :data="addForm.produceList" style="width:1050px;margin-left:30px" @expand-change="row=>{currentExpandID = row.id}">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table :data="props.row.process" :border="true">
                <el-table-column label="序号" align="center" width="50px">
                  <template slot-scope="scope">
                    <div>{{scope.$index+1}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="加工步骤" prop="description" align="center" width="100px"></el-table-column>
                <el-table-column label="工艺要求" prop="require" align="center" width="350px">
                  <template slot-scope="scope">
                    <FormatProcessRequire style="text-align: left" :data="scope.row.require"></FormatProcessRequire>
                  </template>
                </el-table-column>
                <el-table-column label="单价(元/kg)" prop="price" align="center">
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="`produceList.${props.$index}.process.${scope.$index}.price`"
                      :rules="{ pattern: /^[0-9]*(\.[0-9]{1,2})?$/, message: '请输入数字(最多两位小数)', trigger: 'blur' }"
                    >
                      <el-input size="small" v-model="addForm.produceList[props.$index].process[scope.$index].price"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="操作员" prop="operator" align="center" width="200px">
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="`produceList.${props.$index}.process.${scope.$index}.operator`"
                    >
                      <el-select v-model="addForm.produceList[props.$index].process[scope.$index].operator" size="small" filterable multiple collapse-tags>
                        <el-option
                          v-for="item in $store.state.operatorList"
                          :key="item"
                          :label="item"
                          :value="item">
                        </el-option>
                      </el-select>
                      <!-- <el-input size="small" v-model="addForm.produceList[props.$index].process[scope.$index].operator"></el-input> -->
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="备注" prop="remark" align="center">
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="`produceList.${props.$index}.process.${scope.$index}.remark`"
                    >
                      <el-input size="small" v-model="addForm.produceList[props.$index].process[scope.$index].remark"></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="50px" fixed="right">
                  <template slot-scope="scope">
                    <el-link type="primary" @click="onDeleteProcessItem(props.$index, scope.$index)">删除</el-link>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="customer_name" label="客户名称" width="150px"></el-table-column>
          <el-table-column align="center" prop="product_name" label="产品名称" width="150px"></el-table-column>
          <el-table-column align="center" prop="product_size" label="产品规格" width="150px"></el-table-column>
          <el-table-column align="center" prop="product_count" label="来料数量" width="150px">
            <template slot-scope="scope">
              <el-form-item
                :prop="`produceList.${scope.$index}.come_count`"
                :rules="{ pattern: /^\d*$/, message: '请输入数字', trigger: 'blur' }"
              >
                <el-input size="small" v-model="addForm.produceList[scope.$index].come_count"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="supplier" label="供料厂商" width="150px">
          </el-table-column>
          <el-table-column align="center" prop="come_date" label="来料日期">
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="dialogVisible=false">取消</el-button>
        <el-button size="small" type="primary" @click="openCarouselPage">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import FormatProcessRequire from '../components/FormatProcessRequire'
export default {
  props: ['selectList'],
  components: {
    FormatProcessRequire
  },
  data () {
    return {
      dialogVisible: false,
      tableHeight: 300,
      addForm: {
        produceList: []
      }
    }
  },
  mounted () {
    var tableHeight = window.innerHeight * 0.5
    this.tableHeight = tableHeight
  },
  watch: {
    selectList: {
      handler (selectList) {
        let copySelectList = JSON.parse(JSON.stringify(selectList))
        this.addForm.produceList = copySelectList.map(item => {
          item.process = item.process.map(ele => {
            let currentProcess = this.$store.state.processesList.find(item => item.name === ele.description)
            if (currentProcess && currentProcess.price) {
              ele.price = currentProcess.price
            } else {
              ele.price = ''
            }
            ele.operator = []
            ele.remark = ''
            return ele
          })
          return item
        })
      }
    }
  },
  methods: {
    onDeleteProcessItem (produceIndex, processIndex) {
      this.addForm.produceList[produceIndex].process.splice(processIndex, 1)
    },
    showDialog () {
      if (this.selectList.length === 0) {
        this.$message.error('请至少选择一个产品')
        return
      }
      this.dialogVisible = true
    },
    openCarouselPage () {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          localStorage.setItem('carouselData', JSON.stringify(this.addForm.produceList))
          let routeData = this.$router.resolve({
            path: '/carouselPage'
            // query: {
            //   info: JSON.stringify(this.addForm.produceList)
            // }
          })
          window.open(routeData.href, '_blank')
        }
      })
    }
  }
}
</script>

<style scoped>
.container{
  overflow: auto;
}
.el-form--inline .el-form-item{
    margin-right: 0;
    /* margin-bottom: 0!important; */
}
</style>
